// One rule, used by the dashboard and by the report breakdowns: an archived
// category disappears from every selection field, but never silently from a
// period that still carries its spending. Archived AND empty would only add
// a 0/0 row, so those drop out.
//
// `budget` and `actual` are the two blocks of one period as built in
// services/api.js — both keyed by category code.

export const carriesData = (code, budget, actual) =>
  (budget?.dailyTransactions?.[code] || 0) !== 0 ||
  (actual?.dailyTransactions?.[code] || 0) !== 0;

export const relevantExpenseCategories = (categories, budget, actual) =>
  (categories || []).filter(
    (category) =>
      category.kind === 'expense' &&
      (category.is_active !== false || carriesData(category.code, budget, actual))
  );
